import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Bridge from "./sections/Bridge";
import CaseStudies from "./sections/CaseStudies";
import CapabilityReview from "./sections/CapabilityReview";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Bridge />
      <CaseStudies />
      <CapabilityReview />
      <Footer />
    </div>;
}